import { Button, Dialog } from 'evergreen-ui';
import React, { useEffect, useState } from 'react';
import { GrClose } from 'react-icons/gr';
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import styled from 'styled-components';

export const ProjectDetails = ({ isShown, setIsShown, projectInfo }: any) => {

    const [images, setImages] = useState<any>();


    useEffect(() => {
        let img: any[] = [];
        if (projectInfo) {

            projectInfo.images.forEach((image: string) => {
                const item: ReactImageGalleryItem = {
                    original: image,
                    thumbnail: image,
                    thumbnailHeight: 10
                }
                img.push(item);
            });
            setImages(img);
        }
    }, [projectInfo])

    return (
        <>
            <Dialog
                isShown={isShown}
                title='Project Details'
                minHeightContent={0}
                width='600px'
                intent='danger'
                confirmLabel='Delete'
                hasHeader={false}
                hasFooter={false}
                onCloseComplete={() => setIsShown(false)}
            >
                {({ close }) => (
                    <>
                        <div className='flex justify-between pt-3'>
                            <h3 className='text-blue-600 font-semibold'>{projectInfo?.projectNameEn}</h3>
                            <Button appearance='minimal' onClick={close} ><GrClose /></Button>
                        </div>
                        <div className='grid grid-cols-2 gap-2'>
                            <GalleryContainer>
                                <ImageGallery autoPlay={true} items={images} showFullscreenButton={false} showPlayButton={false} showNav={false} />
                            </GalleryContainer>
                            <div className='px-5 font-sans'>
                                <div><strong>Project Code:</strong> {projectInfo.id}</div>
                                <div><strong>Project Name Arabic:</strong> {projectInfo.projectNameAr}</div>
                                <div><strong>Description:</strong> {projectInfo.descriptionEn}</div>
                                <div><strong>Description Arabic:</strong> {projectInfo.descriptionAr}</div>
                            </div>

                        </div>
                    </>
                )}
            </Dialog>
        </>
    )
}

const GalleryContainer = styled.div`
    .image-gallery {
        height: 300px;
        width: auto;
    }
    .image-gallery-thumbnail{
        height: 50px;
        width: 50px;
    }
`